import {Box, BoxProps} from '@chakra-ui/react';

import {GroundMarksIcon} from '../components/playground-lineup';

import type {Player} from '../types';
import {useLineupStore, getPositionFromIndex} from './useLineupStore';
import {EditablePlayerSpot} from './EditablePlayerSpot';

type LineupProps = {
  isEditable?: boolean;
} & BoxProps;

export function EditablePlaygroundLineup({isEditable = true, ...props}: LineupProps) {
  const lineup = useLineupStore(
    (state) => state.formation.split('-').map((item) => Array.from({length: Number(item)}).fill(null)),
    (prevState, newState) =>
      prevState !== null &&
      newState !== null &&
      prevState[0].length === newState[0].length &&
      prevState[1].length === newState[1].length &&
      prevState[2].length === newState[2].length,
  ) as [Array<null>, Array<null>, Array<null>];

  return (
    <Box p={[1, null, 2]} w="full" sx={{aspectRatio: '580/473'}} backgroundColor="green.400" roundedTop="md" {...props}>
      <Box pos="relative" w="full" h="full" zIndex={1}>
        <GroundMarksIcon pos="absolute" inset={0} zIndex={-1} />

        <Box
          data-testid="playground"
          className="player-groups"
          h="full"
          p={[0.5, null, 1]}
          display="flex"
          flexDir="column"
          gap="3.3%"
          justifyContent="space-between"
        >
          <Box className="player-group" w="full" minH="20%" flex={1} display="flex" justifyContent="center">
            <EditablePlayerSpot position="Goalkeeper" index={0} data-testid={'0-0'} isEditable={isEditable} />
          </Box>

          {lineup.map((playerGroup: (Player | null)[], lineIndex) => (
            <Box
              className="player-group"
              key={`${lineIndex}-${playerGroup.length}`}
              w="full"
              minH="20%"
              flex={1}
              display="flex"
              justifyContent="center"
              gap="min(1%, 0.375rem)"
              px="2%"
            >
              {playerGroup.map((_, playerIndex) => (
                <EditablePlayerSpot
                  data-testid={`${lineIndex + 1}-${playerIndex}`}
                  key={`${getPositionFromIndex((lineIndex + 1) as 1 | 2 | 3)}-${playerIndex}`}
                  position={getPositionFromIndex((lineIndex + 1) as 1 | 2 | 3)}
                  index={playerIndex}
                  isEditable={isEditable}
                />
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
